<template>
  <div class="app-container">
      <el-form :model="queryParams" ref="queryForm" :inline="true" style="overflow: hidden; clear: both;">
          <el-form-item label="公告编号" class="f-item">
            <el-input
              style="width: 300px;"
              v-model="queryParams.code"
              placeholder="请输入公告编号"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="公告名称" class="f-item">
            <el-input
              style="width: 300px;"
              v-model="queryParams.title"
              placeholder="请输入公告名称"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="当前状态" class="f-item">
            <el-select v-model="queryParams.status" placeholder="请选择当前状态" clearable size="small">
              <el-option
                v-for="dict in stateOptions"
                :key="dict.dictValue"
                :label="dict.dictLabel"
                :value="dict.dictValue"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="float: right">
            <el-button type="blue" size="mini" @click="handleQuery">搜索</el-button>
          </el-form-item>
        </el-form>
      
        <el-row :gutter="10" class="mb8">
          <el-col :span="1.5">
            <el-button
              type="blue"
              icon="el-icon-plus"
              size="mini"
              @click="handleAdd('')"
            >公示公告发布</el-button>
          </el-col>
        </el-row>

    <el-table v-loading="loading" stripe :data="arbitrateRecords">
      <el-table-column  type="index" label="序号" width="70" align="center"/>
      <el-table-column label="公告编号" align="center" prop="code" min-width="130"/>
      <el-table-column label="订单流水号" align="center" prop="payOrderId"  width="150" />
      <el-table-column label="业务场景" align="center" prop="sceneType" :formatter="sceneTypeFormat"/>
      <el-table-column label="公告名称" align="center" prop="title" min-width="360"/>
      <el-table-column label="发布人" align="center" prop="creatorName" width="150"/>
      <el-table-column label="项目经理手机号" align="center" prop="managerPhone" width="120"/>
      <el-table-column prop="publishTime" label="发布时间" width="150" align="center" >
        <template slot-scope="scope">
          {{scope.row.status=='3' || scope.row.status=='4'?scope.row.publishTime:'-'}}
        </template>
      </el-table-column>
      <el-table-column prop="noticeUrl" label="公告链接" width="150" align="center" >
        <template slot-scope="scope">
          <a class="t-link" v-if="scope.row.status=='3'" target="_blank" :href="`${chdigiUrl}/detail?id=${scope.row.id}&type=notice&ins=1`">链接地址</a>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="支付方式" align="center" prop="payType" width="100" >
        <template slot-scope="scope">
          {{scope.row.payType == 'online' ? '线上支付' : '线下支付'}}
        </template>
      </el-table-column>
      
      <el-table-column label="当前状态" align="center" prop="status" width="100" :formatter="stateFormat"></el-table-column>
      <el-table-column label="操作" align="center" width="140" class-name="small-padding fixed-width" fixed="right">
        <template slot-scope="scope">
          <span class="f-blue" @click="handleDetial(scope.row.id)">详情</span>
          <span class="f-blue" v-if="scope.row.status=='2'" @click="handleAdd(scope.row.id)" style="margin-left:5px">编辑</span>
          <span class="f-blue" v-if="scope.row.status=='2'" @click="handleDel(scope.row.id)" style="margin-left:5px">删除</span>
          <a :href="scope.row.fileUrl" v-if="scope.row.status=='3'" class="f-blue" style="margin-left:5px">存证文件</a>
          <span class="f-blue" v-if="scope.row.status=='3'" @click="preview(scope.row)">下载链证报告</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="toolbar">
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :current-page.sync="queryParams.pageNum" :page-size="queryParams.pageSize" :total="total">
        </el-pagination>
    </div>

  </div>
</template>

<script>
import baseUrl from '@/api/baseUrl.js' 
export default {
  name: "notice",
  components: {

  },
  data() {
    return {
      headers: {},
      loading: true,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userId: sessionStorage.account
      },
      total: 0,
      arbitrateRecords: [],
      open: false,
      sceneOptions: [
        {
          dictLabel: "拍卖",
          dictValue: "1"
        }
      ],
      stateOptions: [
       {
          dictLabel: "待审核",
          dictValue: "0"
        },
        {
          dictLabel: "待发布",
          dictValue: "1"
        },
        {
          dictLabel: "已拒绝",
          dictValue: "2"
        },
        {
          dictLabel: "已发布",
          dictValue: "3"
        },
        {
          dictLabel: "隐藏",
          dictValue: "4"
        }
      ],
      account: sessionStorage.account,
      idNo: '',
      companyType: '',
      chdigiUrl: ''
    }
  },
  created() {
    this.chdigiUrl = baseUrl.chdigiUrl
    this.getList()
    this.getInf()
  },
  methods: {
    selectDictLabel(datas, value) {
      var actions = [];
      Object.keys(datas).some((key) => {
        if (datas[key].dictValue == ('' + value)) {
          actions.push(datas[key].dictLabel);
          return true;
        }
      })
      return actions.join('');
    },
    sceneTypeFormat(row) {
      return this.selectDictLabel(this.sceneOptions, row.sceneType);
    },
    stateFormat(row) {
      return this.selectDictLabel(this.stateOptions, row.status);
    }, 
    getInf(){
      this.$api.api.getInfoByAccount({account: this.account}).then(response => {
        this.companyType = response.data.companyType
        this.idNo = response.data.idNo
      });
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },   
    getList() {
      let queryParams = Object.assign({}, this.queryParams);
      this.$api.api.queryNoticePubPageList(queryParams).then(response => {
        this.loading = false
        if(response.code==200){
          this.arbitrateRecords = response.rows;
          this.total = response.total;
        }else {
          this.$message.error(response.msg);
        }    
      });
    },  
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        userId: sessionStorage.account
      }
      this.handleQuery();
    },
    preview(row) {
      window.open(`${baseUrl.newucUrl}/iacc-notice/arbitrate/noticePubReportPreview?id=${row.id}`) 
    },
    handleAdd(id=""){
      if(this.companyType == '01'){
        this.$message.warning("您还不是机构用户，谢谢！");        
      }else {
        this.$router.push({path: `/addRelease?id=${id}`});
      }
    }, 
    handleDetial(id){
      this.$router.push({path: `/rDetail?id=${id}`});
    }, 
    /** 删除 */
    handleDel(id) {
      this.$confirm("确定删除此公告信息吗？", "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$api.api.deleteNoticePub({id}).then(response => {
            if(response.code==200){
              this.$message.success(response.msg);
              this.getList()
            }else {
              this.$message.error(response.msg);
            }    
          });
          
        }).then(response => {
          
        })     
    }
  }
}
</script>

<style>
.wrap{word-wrap:break-word; word-break:break-all;}
</style>
